import React from "react";
import { Grid, Skeleton } from "@mui/material";

const DetailTableViewSmallRowSkeleton: React.FC = (props) => {
  return (
    <Grid
      direction="row"
      container
      item
      padding={2}
      paddingRight={3}
      justifyContent="center"
      alignItems="center"
      height={"20px"}
      width={"100%"}
    >
      <Grid item xs={6}>
        <Skeleton variant="rounded" width="60%" height="8px" />
      </Grid>
      <Grid item xs={6}>
        <Skeleton variant="rounded" width="60%" height="8px" />
      </Grid>
    </Grid>
  );
};

export default DetailTableViewSmallRowSkeleton;
